export const APP_STORE_LINK =
  "https://apps.apple.com/us/app/stockperks/id1500953549";
export const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.stockperks.stockperks";
